// 测速前弹窗逻辑
import api from '../config/api';
import {myStorage} from "../utils/localStorage";
import {getQueryVariable} from "../globalFunction";

export default {
    data() {
        return {
            indexActivesId: [],
            indexActivesDetail: [],
            popIndex: [],
            /*
            *  'wuxi_activity' => '无锡信息收集活动',
                'chuzhou_activity' => '滁州信息收集活动',
                'new_activity' => '新人好礼活动',
                'renewal_activity' => '续费送优惠券活动',
                'speedup_activity' => '宽带提速活动',
                'app_activity' => 'APP下载活动',
            * */
            actvieType: {
                'wuxi_activity': this.judgeWuxi,
                'chuzhou_activity': this.judgeChuzhou,
                'new_activity': this.judgeNew,
                'renewal_activity': this.judgeRenewal,
                'speedup_activity': this.judgeSpeedup,
                'app_activity': this.judgeApp,
                'cate2Common': this.cate2Common,
                'isp_satisfaction_activity': this.ispSatisfactionActivity
            },
            isShowWuXiPop: false, //无锡移动弹窗
            isShowNewPeoplePop: false, //新人好礼弹窗
            newPeoplePopInfo: null, //新人好礼信息
            isChuZhouPopShow: false, //滁州联通的弹窗是否展示
            chuZhouInfo: null, //滁州联通信息
            renewalCouponInfo: null, //提速优惠券续费信息
            isShowRenewalCoupon: false, //提速优惠券弹窗
            broadbandUpInfo: null, //宽带提速弹窗内容
            isShowBroadbandUpPop: false, //是否显示宽带提速
            isShowAppPop: false, //是否显示app下载pop
            activityInfos:{},
            isShowCate2Common: false, //是否展示通用图片类
            cate2CommonInfo: {}, //通用信息弹窗
            isShowIspSatisfactionActivity: false, //宽带满意度弹窗
            ispSatisfactionActivityInfo: {}, //宽带满意度信息
        }
    },
    methods: {
        // 原生用户满意度弹窗
        async ispSatisfactionActivity(data) {
            this.ispSatisfactionActivityInfo = data
            let submitBool = !(data.activityContent&&data.activityContent.isSubmit)
            let localInfo = this.getLocalKey('indexPop')
            let oldTime = ''
            if (localInfo) {
                let index = localInfo.findIndex(item => {
                    return item.type === data.type
                })
                oldTime = index === -1 ? '' : localInfo[index].time
            }
            let time = new Date()
            let testEndTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
            this.isShowIspSatisfactionActivity = testEndTime !== oldTime && submitBool;
            return !this.isShowIspSatisfactionActivity
        },
        /*通用图片类*/
        async cate2Common(data) {
            this.cate2CommonInfo = data
            let submitBool = !(data.activityContent&&data.activityContent.isSubmit)
            let localInfo = this.getLocalKey('indexPop')
            let oldTime = ''
            if (localInfo) {
                let index = localInfo.findIndex(item => {
                    return item.type === data.type
                })
                oldTime = index === -1 ? '' : localInfo[index].time
            }
            let time = new Date()
            let testEndTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
            this.isShowCate2Common = testEndTime !== oldTime && submitBool;
            return !this.isShowCate2Common
        },
        /*无锡类型活动*/
        async judgeWuxi(data) {
            this.testEndFormData = data.activityContent;
            // isSubmit 七天之内没有提交反馈信息 true:七天之内有提交反馈信息
            let submitBool = !this.testEndFormData.isSubmit
            // 获取本地存储里的时间
            let localInfo = this.getLocalKey('indexPop')
            let oldTime = ''
            if (localInfo) {
                let index = localInfo.findIndex(item => {
                    return item.type === data.type
                })
                oldTime = index === -1 ? '' : localInfo[index].time
            }
            let time = new Date()
            let testEndTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
            this.isShowWuXiPop = testEndTime !== oldTime && submitBool;
            return !this.isShowWuXiPop
        },
        /*滁州类型活动判断*/
        async judgeChuzhou(data) {
            this.chuZhouInfo = data
            let submitBool = !data.activityContent.isSubmit
            let localInfo = this.getLocalKey('indexPop')
            let oldTime = ''
            if (localInfo) {
                let index = localInfo.findIndex(item => {
                    return item.type === data.type
                })
                oldTime = index === -1 ? '' : localInfo[index].time
            }
            let time = new Date()
            let testEndTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
            this.isChuZhouPopShow = testEndTime !== oldTime && submitBool;
            return !this.isChuZhouPopShow
        },
        /*新人好礼活动*/
        async judgeNew(data) {
            let activityContent = data.activityContent
            // 未领取可能是未登录
            let submitBool = !activityContent.isSubmit
            // 获取本地存储里的时间
            let localInfo = this.getLocalKey('indexPop')
            let oldTime = ''
            if (localInfo) {
                let index = localInfo.findIndex(item => {
                    return item.type === data.type
                })
                oldTime = index === -1 ? '' : localInfo[index].time
            }
            let time = new Date()
            let testEndTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
            this.isShowNewPeoplePop = testEndTime !== oldTime && submitBool;
            this.newPeoplePopInfo = data
            return !this.isShowNewPeoplePop

        },
        /*续费送优惠券活动*/
        async judgeRenewal(data) {
            this.renewalCouponInfo = data
            let canShowPop = false
            if (this.indexInfo) {
                /**
                 * 已开通，即将到期的（剩余时长小于等于3天的，大于0小时）  此弹窗每天至多弹一次，每天24点刷新次数
                 */
                let indexInfo = this.indexInfo
                if (indexInfo.speedUpType === 2) {
                    //过期的弹窗
                    canShowPop = true
                }
                if (indexInfo.expireTime) {
                    //快过期
                    const expireTime = indexInfo.expireTime
                    const endDay = new Date(expireTime).getTime()
                    const nowDay = new Date(new Date().toLocaleDateString()).getTime()
                    // 开通且剩余时间小于三天
                    if (endDay > nowDay && (endDay - nowDay) <= 345600000) {
                        canShowPop = true
                    }

                }
            }
            let localInfo = this.getLocalKey('indexPop')
            let oldTime = ''
            if (localInfo) {
                let index = localInfo.findIndex(item => {
                    return item.type === data.type
                })
                oldTime = index === -1 ? '' : localInfo[index].time
            }
            let time = new Date()
            let testEndTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
            this.isShowRenewalCoupon = testEndTime !== oldTime && canShowPop;
            return !this.isShowRenewalCoupon
        },
        /*宽带提速活动*/
        async judgeSpeedup(data) {
            this.broadbandUpInfo = data
            let localInfo = this.getLocalKey('indexPop')
            let oldTime = ''
            if (localInfo) {
                let index = localInfo.findIndex(item => {
                    return item.type === data.type
                })
                oldTime = index === -1 ? '' : localInfo[index].time
            }
            let time = new Date()
            let testEndTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
            this.isShowBroadbandUpPop = testEndTime !== oldTime;
            return !this.isShowBroadbandUpPop
        },
        /*APP下载活动*/
        async judgeApp(data) {
            let localInfo = this.getLocalKey('indexPop')
            let oldTime = ''
            if (localInfo) {
                let index = localInfo.findIndex(item => {
                    return item.type === data.type
                })
                oldTime = index === -1 ? '' : localInfo[index].time
            }
            let time = new Date()
            let testEndTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
            this.isShowAppPop = testEndTime !== oldTime;
            if(this.isShowAppPop) {
                this.showDownloadTips();
            }
            return !this.isShowAppPop
        },
        getIndexPop() {
            api.getActiveLists({
                source: 'www',
                popupType: 1,
                version: 'new',
            }).then(res => {
                if (res.code === 0) {
                    this.indexActivesId = res.data
                    this.getLocalInfo(res.data)
                }
            })
        },
        /*获取活动具体信息*/
        async getIndexActiveDetail(id, first) {
            let res = await api.getActiveDetail({
                id,
                network: 1,
                udid: localStorage.getItem('udid')
            })
            if (res.data) {
                let {type,cate} = res.data
                this.activityInfos[type]=res.data
                // 此处为了修复之前的逻辑 弹窗应该安装三大类来分，之前按照六小类没有通用性
                // 此次不改之前定义六种类型方法，后续新增的类型按照三大类分
                if(!this.actvieType[type]) {
                    if (cate==='2') {
                        // 后续新增的
                        type = 'cate2Common'
                    }
                }
                return await (this.actvieType[type])(res.data);
            }
            return true
        },
        /*获取本地的存储数据*/
        async getLocalInfo(data) {
            let localInfo = this.getLocalKey('indexPop')
            if (localInfo && localInfo.length) {
                if (data && data.length) {
                    let popId = null
                    for (let i = 0; i < data.length; i++) {
                        let activeItem = data[i];
                        let index = localInfo.findIndex(item => {
                            return item.type === activeItem.type
                        })
                        if (index === -1) {
                            //本地并未弹出过这个弹窗
                            popId = activeItem.id
                            let isContinue = await this.getIndexActiveDetail(popId)
                            if (!isContinue) break
                        } else {
                            // 有弹出记录 取弹出记录判断当时是否弹出
                            let oldTime = localInfo[index].time
                            let time = new Date()
                            let currentTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
                            if (currentTime !== oldTime) {
                                //本地存的弹出时间和当前时间不一致 代表当日弹出 进一步查询详情来判断是否可以弹出
                                popId = activeItem.id
                                let isContinue = await this.getIndexActiveDetail(popId)
                                if (!isContinue) break
                            } else {
                                // 今天弹出过下一个
                            }
                        }
                    }
                }
            } else {
                //第一次打开
                for (let i = 0; i < data.length; i++) {
                    let activeItem = data[i];
                    let isContinue = await this.getIndexActiveDetail(activeItem.id)
                    // isContinue 为false 直接退出循环
                    if (!isContinue) return;


                }
            }
        },

        getLocalKey(key) {
            let localInfo = null
            if (localStorage.getItem(key)) {
                try {
                    localInfo = JSON.parse(localStorage.getItem(key))
                } catch (e) {

                }
            }
            return localInfo
        },
        //打开新的落地页
        jumpUrl() {
            if (sessionStorage.getItem('jumpTo')) {
                let url = sessionStorage.getItem('jumpTo')
                sessionStorage.removeItem('jumpTo')
                window.open(url)
            }
        }

    },
    created() {
        if(location.pathname==='/') {
           setTimeout(()=>{
               this.getIndexPop()
           },1000)
        }
        //this.jumpUrl()
    },
}



// WEBPACK FOOTER //
// ./resources/js/mixin/indexPop.js